import type { FaireProductEntity } from "../../entity_types/product";

export const p_8pkemggfvf: FaireProductEntity = {
  token: "p_8pkemggfvf",
  type: "product",
  name: "Bunch of Cats Blue Porcelain Yunomi Tea Cup – 10 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/5a73caea866056344ff834ea1cedfc3bc42f2e418f92d131fd6834949ba5f5b0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b61d73fe2d0be2c500620c5d18aa9909c6f92bc9d2fd925d5d6088ae10f2211.jpeg",
    "https://cdn.faire.com/fastly/bde1a7cdd9c0dd970528686d418a6bb03ae06d4b7c2ec31cdb5595bd81b3ac00.jpeg",
    "https://cdn.faire.com/fastly/687efc0f5ae1e0ab591be13a7aa3ccbe49a904bae314587e64c6d039d952de31.jpeg"
  ],
  priceDollars: 5.5,
  description: "Serve hot green tea the Japanese way with this 10 oz yunomi tea cup in Bunch of Cats Blue. It is decorated with a playful bunch of cats in blue. Made in Japan from durable porcelain, it is built for sushi bars, ramen shops, cafés and Japanese restaurants, while looking just as good at home. A thoughtful gift for tea lovers and cat fans.\n\nFeatures\n\n * Classic yunomi shape: a tall, handleless cup that is comfortable to hold with both hands \n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 2.75\" Dia x 4\" H \n * Capacity: 10 fl oz \n * Material: Porcelain \n * Design: Bunch of Cats Blue \n * Inner pack: 6 \n * Case pack: 60 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:56.722Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
